import React from 'react'
import BrxSlider from '../components/BrxSlider'

const Brch = () => {
  return (
    <>
      <div>
        <BrxSlider/>
    </div>
    
    </>
    
      
        
       
  )
}

export default Brch